import { gql } from "@apollo/client";

export const GetItemsDetailsById = gql`
  query GetItemsDetailsById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      ... on AtsStckItemDetails {
        id
        transEntryType
        transMadeOn
        address
        qrCode
        transDate
        alias
        ticketStatus
        poleNum
        prodSerialNo
        prodBatchNo
        prodBrand
        prodModel
        prodExpiryDate
        prodWarrantyStartDate
        prodWarrantyEndDate
        prodInstallationEndDate
        prodAmcStDate
        prodAmcEndDate
        prodInsuranceStDate
        prodInsuranceEndDate
        prodLatitude
        prodLongitude
        propertyData1
        propertyData2
        propertyData3
        propertyData4
        propertyData5
        propertyData6
        propertyData7
        propertyData8
        propertyData9
        propertyData10
        customerID
        itemID
        initCompanyID
        initSubsidiaryID
        initSiteID
        initJunctionID
        curCompanyID
        curSubsidiaryID
        curSiteID
        curJunctionID
        voucherID
        ldgrID
        item {
          desc
        }
      }
    }
  }
`;
